import { ControllerParams } from '@wix/yoshi-flow-editor';

type ErrorMonitor = ReturnType<ControllerParams['flowAPI']['panoramaClient']['errorMonitor']>;

export const normalizeError = (error: any) => {
  if (
    typeof Response !== 'undefined' &&
    error instanceof Response &&
    error.constructor.name !== 'Error'
  ) {
    return Error(`Failed to fetch ${error.url} with status ${error.status} - ${error.statusText}`);
  }
  return error;
};

export const decorateActionsWithLogger = <T extends Record<string, Function>>(
  actions: T,
  errorMonitor: ErrorMonitor,
  logToConsole: boolean,
): T => {
  const decoratedActions: any = {};
  const decorate =
    (action: Function, key: string) =>
    (...args: any[]) => {
      const captureError = (e: any) =>
        errorMonitor.reportError(normalizeError(e), {
          context: { action: { action: key } },
          tags: { ...e.tags, capturedBy: 'action monitor', requestId: e.requestId },
        });
      try {
        const response = action(...args);
        if (response instanceof Promise) {
          response.catch((error) => {
            const status = error?.status ?? error?.response?.status;
            if (![200, 500, 400, 422, 428].includes(status)) {
              return;
            }

            const eventId = captureError(error);
            logToConsole && console.error(error, eventId);
          });
        }
        return response;
      } catch (error) {
        const eventId = captureError(error);
        logToConsole && console.error(error, eventId);
      }
    };

  Object.keys(actions).forEach((key) => {
    const action = actions[key];
    decoratedActions[key] = decorate(action, key);
  });

  return decoratedActions;
};
